import React, { useState } from 'react';
import { X, Plus, CalendarDays, Layers, Package, ShoppingBag, Eye, DollarSign, ToggleRight, ToggleLeft, Edit2, Trash2 } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { Input } from '../ui/Input';
import { ImageUpload } from '../ui/ImageUpload';
interface ProductsTabProps {
  showToast: (msg: string) => void;
}
export function ProductsTab({
  showToast
}: ProductsTabProps) {
  const [isEditingProduct, setIsEditingProduct] = useState(false);
  const [products, setProducts] = useState([{
    id: 1,
    title: 'Основы ведической астрологии: с нуля до первых прогнозов',
    category: 'Курсы и марафоны',
    price: '15 000 ₽',
    sales: 12,
    views: 340,
    revenue: '180 000 ₽',
    color: 'bg-indigo-100',
    active: true
  }, {
    id: 2,
    title: 'Вебинар: Как пережить ретроградный Меркурий',
    category: 'Вебинары',
    price: '990 ₽',
    sales: 45,
    views: 890,
    revenue: '44 550 ₽',
    color: 'bg-amber-100',
    active: true
  }, {
    id: 3,
    title: 'Астро-календарь на Ноябрь 2024',
    category: 'Астро-календарь',
    price: '1 490 ₽',
    sales: 67,
    views: 1240,
    revenue: '99 830 ₽',
    color: 'bg-purple-100',
    active: true
  }, {
    id: 4,
    title: 'Полный разбор: Натальная + Соляр + Синастрия',
    category: 'Пакет разборов',
    price: '12 000 ₽',
    sales: 8,
    views: 210,
    revenue: '96 000 ₽',
    color: 'bg-emerald-100',
    active: true
  }, {
    id: 5,
    title: '3 разбора натальной карты по цене 2',
    category: 'Пакет разборов',
    price: '10 000 ₽',
    sales: 14,
    views: 380,
    revenue: '140 000 ₽',
    color: 'bg-emerald-100',
    active: true
  }]);
  const handleDeleteProduct = (productId: number) => {
    setProducts(prev => prev.filter(p => p.id !== productId));
    showToast('Товар удалён');
  };
  const handleToggleProductActive = (productId: number) => {
    setProducts(prev => prev.map(p => p.id === productId ? {
      ...p,
      active: !p.active
    } : p));
    showToast('Статус товара изменён');
  };
  if (isEditingProduct) {
    return <div className="space-y-6" data-id="element-12250">
        <div className="flex items-center gap-4 mb-6" data-id="element-12251">
          <button onClick={() => setIsEditingProduct(false)} className="p-2 hover:bg-slate-100 rounded-full transition-colors" data-id="element-12252">
            <X className="w-5 h-5 text-slate-500" data-id="element-12253" />
          </button>
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-12254">
            Добавление товара
          </h2>
        </div>

        <Card padding="lg" data-id="element-12255">
          <form className="space-y-6" data-id="element-12256">
            <div className="space-y-4" data-id="element-12257">
              <Input label="Название товара/курса" placeholder="Например: Курс 'Основы астрологии'" data-id="element-12258" />

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-12259">
                <div data-id="element-12260">
                  <label className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-12261">
                    Категория
                  </label>
                  <select className="block w-full rounded-xl border-slate-200 px-4 py-2.5 border focus:ring-primary focus:border-primary outline-none text-sm bg-white" data-id="element-12262">
                    <option data-id="element-12263">Курсы и марафоны</option>
                    <option data-id="element-12264">Вебинары</option>
                    <option data-id="element-12265">Письменные разборы</option>
                    <option data-id="element-12266">Консультации</option>
                    <option data-id="element-12267">Астро-календарь</option>
                    <option data-id="element-12268">Пакет разборов</option>
                  </select>
                </div>
                <Input label="Цена (₽)" type="number" placeholder="5000" data-id="element-12269" />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-12270">
                <Input label="Формат" placeholder="Онлайн-курс, PDF, Видеозвонок" data-id="element-12271" />
                <Input label="Длительность / Срок" placeholder="4 недели, 60 мин, 3 дня" data-id="element-12272" />
              </div>

              <div data-id="element-12273">
                <label className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-12274">
                  Описание
                </label>
                <textarea className="w-full rounded-xl border-slate-200 px-4 py-3 border focus:ring-primary focus:border-primary outline-none text-sm" rows={5} placeholder="Подробно опишите, что получит клиент..." data-id="element-12275" />
              </div>

              <ImageUpload label="Обложка товара" value="" onChange={() => {}} height="h-40" data-id="element-12276" />
            </div>

            <div className="flex justify-end gap-3 pt-6 border-t border-slate-100" data-id="element-12277">
              <Button variant="outline" onClick={() => setIsEditingProduct(false)} data-id="element-12278">
                Отмена
              </Button>
              <Button variant="primary" onClick={() => setIsEditingProduct(false)} data-id="element-12279">
                Опубликовать в Маркетплейсе
              </Button>
            </div>
          </form>
        </Card>
      </div>;
  }
  return <div className="space-y-6" data-id="element-12280">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-2" data-id="element-12281">
        <div data-id="element-12282">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-12283">Мои товары</h2>
          <p className="text-sm text-slate-500 mt-1" data-id="element-12284">
            Управление курсами, вебинарами, пакетами и услугами в Маркетплейсе
          </p>
        </div>
        <Button variant="primary" size="sm" icon={<Plus className="w-4 h-4" data-id="element-12286" />} onClick={() => setIsEditingProduct(true)} data-id="element-12285">
          Новый товар
        </Button>
      </div>

      {/* Quick-create premium product types */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-12287">
        <Card padding="md" className="border-purple-100 bg-gradient-to-br from-purple-50/60 to-white hover:border-purple-200 transition-colors" data-id="element-12288">
          <div className="flex items-start gap-4" data-id="element-12289">
            <div className="w-12 h-12 rounded-xl bg-purple-100 flex items-center justify-center flex-shrink-0" data-id="element-12290">
              <CalendarDays className="w-6 h-6 text-purple-600" data-id="element-12291" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-12292">
              <h4 className="font-bold text-slate-900 mb-1 flex items-center gap-2" data-id="element-12293">
                Астро-календарь
                <Badge variant="pro" size="sm" className="bg-purple-100 text-purple-700 border-purple-200" data-id="element-12294">
                  Платная услуга
                </Badge>
              </h4>
              <p className="text-sm text-slate-600 mb-3" data-id="element-12295">
                Создайте ежемесячный астро-календарь с описанием транзитов,
                аспектов и рекомендациями на каждый день. Клиенты покупают
                подписку или отдельные месяцы.
              </p>
              <div className="flex flex-wrap gap-2 mb-3" data-id="element-12296">
                <span className="text-[11px] bg-purple-50 text-purple-600 px-2 py-0.5 rounded-full font-medium" data-id="element-12297">
                  Транзиты планет
                </span>
                <span className="text-[11px] bg-purple-50 text-purple-600 px-2 py-0.5 rounded-full font-medium" data-id="element-12298">
                  Лунные фазы
                </span>
                <span className="text-[11px] bg-purple-50 text-purple-600 px-2 py-0.5 rounded-full font-medium" data-id="element-12299">
                  Рекомендации дня
                </span>
                <span className="text-[11px] bg-purple-50 text-purple-600 px-2 py-0.5 rounded-full font-medium" data-id="element-12300">
                  Ретрограды
                </span>
              </div>
              <Button variant="outline" size="sm" className="border-purple-200 text-purple-700 hover:bg-purple-50" icon={<Plus className="w-3.5 h-3.5" data-id="element-12302" />} onClick={() => setIsEditingProduct(true)} data-id="element-12301">
                Создать календарь
              </Button>
            </div>
          </div>
        </Card>

        <Card padding="md" className="border-emerald-100 bg-gradient-to-br from-emerald-50/60 to-white hover:border-emerald-200 transition-colors" data-id="element-12303">
          <div className="flex items-start gap-4" data-id="element-12304">
            <div className="w-12 h-12 rounded-xl bg-emerald-100 flex items-center justify-center flex-shrink-0" data-id="element-12305">
              <Layers className="w-6 h-6 text-emerald-600" data-id="element-12306" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-12307">
              <h4 className="font-bold text-slate-900 mb-1 flex items-center gap-2" data-id="element-12308">
                Пакеты разборов
                <Badge variant="success" size="sm" className="bg-emerald-100 text-emerald-700 border-emerald-200" data-id="element-12309">
                  Платная услуга
                </Badge>
              </h4>
              <p className="text-sm text-slate-600 mb-3" data-id="element-12310">
                Объедините несколько разборов в выгодный пакет. Клиенты получают
                скидку, а вы — больше заказов и повышение среднего чека.
              </p>
              <div className="flex flex-wrap gap-2 mb-3" data-id="element-12311">
                <span className="text-[11px] bg-emerald-50 text-emerald-600 px-2 py-0.5 rounded-full font-medium" data-id="element-12312">
                  Натальная + Соляр
                </span>
                <span className="text-[11px] bg-emerald-50 text-emerald-600 px-2 py-0.5 rounded-full font-medium" data-id="element-12313">
                  3 по цене 2
                </span>
                <span className="text-[11px] bg-emerald-50 text-emerald-600 px-2 py-0.5 rounded-full font-medium" data-id="element-12314">
                  Годовое сопровождение
                </span>
              </div>
              <Button variant="outline" size="sm" className="border-emerald-200 text-emerald-700 hover:bg-emerald-50" icon={<Plus className="w-3.5 h-3.5" data-id="element-12316" />} onClick={() => setIsEditingProduct(true)} data-id="element-12315">
                Создать пакет
              </Button>
            </div>
          </div>
        </Card>
      </div>

      {/* Existing Products List */}
      <div className="space-y-4" data-id="element-12317">
        {products.map(product => <Card key={product.id} padding="md" className={`transition-opacity ${!product.active ? 'opacity-60' : ''}`} data-id="element-12318">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4" data-id="element-12319">
              <div className={`w-12 h-12 rounded-xl flex-shrink-0 flex items-center justify-center ${product.color}`} data-id="element-12320">
                {product.category === 'Астро-календарь' ? <CalendarDays className="w-6 h-6 text-purple-700/60" data-id="element-12321" /> : product.category === 'Пакет разборов' ? <Layers className="w-6 h-6 text-emerald-700/60" data-id="element-12322" /> : <Package className="w-6 h-6 text-slate-700/50" data-id="element-12323" />}
              </div>

              <div className="flex-1 min-w-0" data-id="element-12324">
                <div className="flex flex-wrap items-center gap-2 mb-1" data-id="element-12325">
                  <h3 className="font-bold text-slate-900 truncate" data-id="element-12326">
                    {product.title}
                  </h3>
                  <Badge variant={product.category === 'Астро-календарь' ? 'pro' : product.category === 'Пакет разборов' ? 'success' : 'neutral'} size="sm" className={product.category === 'Астро-календарь' ? 'bg-purple-100 text-purple-700 border-purple-200' : product.category === 'Пакет разборов' ? 'bg-emerald-100 text-emerald-700 border-emerald-200' : ''} data-id="element-12327">
                    {product.category}
                  </Badge>
                </div>
                <div className="flex flex-wrap items-center gap-4 text-sm text-slate-500" data-id="element-12328">
                  <span className="font-medium text-slate-900" data-id="element-12329">
                    {product.price}
                  </span>
                  <span className="flex items-center" data-id="element-12330">
                    <ShoppingBag className="w-3.5 h-3.5 mr-1" data-id="element-12331" /> {product.sales}{' '}
                    продаж
                  </span>
                  <span className="flex items-center" data-id="element-12332">
                    <Eye className="w-3.5 h-3.5 mr-1" data-id="element-12333" /> {product.views}{' '}
                    просмотров
                  </span>
                  <span className="flex items-center font-medium text-emerald-600" data-id="element-12334">
                    <DollarSign className="w-3.5 h-3.5 mr-0.5" data-id="element-12335" />{' '}
                    {product.revenue}
                  </span>
                </div>
              </div>

              <div className="flex items-center gap-3 w-full sm:w-auto pt-4 sm:pt-0 border-t sm:border-t-0 border-slate-100 mt-2 sm:mt-0 justify-between sm:justify-end" data-id="element-12336">
                <button onClick={() => handleToggleProductActive(product.id)} className="flex items-center gap-1.5 text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors" data-id="element-12337">
                  {product.active ? <>
                      <ToggleRight className="w-5 h-5 text-emerald-500" data-id="element-12338" />{' '}
                      Активен
                    </> : <>
                      <ToggleLeft className="w-5 h-5 text-slate-400" data-id="element-12339" /> Скрыт
                    </>}
                </button>

                <div className="flex items-center gap-1" data-id="element-12340">
                  <button onClick={() => setIsEditingProduct(true)} className="p-2 text-slate-400 hover:text-primary hover:bg-indigo-50 rounded-lg transition-colors" title="Редактировать" data-id="element-12341">
                    <Edit2 className="w-4 h-4" data-id="element-12342" />
                  </button>
                  <button onClick={() => handleDeleteProduct(product.id)} className="p-2 text-slate-400 hover:text-rose-500 hover:bg-rose-50 rounded-lg transition-colors" title="Удалить" data-id="element-12343">
                    <Trash2 className="w-4 h-4" data-id="element-12344" />
                  </button>
                </div>
              </div>
            </div>
          </Card>)}

        <button onClick={() => setIsEditingProduct(true)} className="w-full flex items-center justify-center gap-2 p-4 rounded-2xl border-2 border-dashed border-slate-200 text-slate-500 hover:text-primary hover:border-primary hover:bg-indigo-50/50 transition-all font-medium" data-id="element-12345">
          <Plus className="w-5 h-5" data-id="element-12346" />
          Создать новый продукт
        </button>
      </div>
    </div>;
}